<template>
  <div class="cbg-white-container input-container theme--light v-card p-16 border-card">
    <div class="col-sm-12 ml-0 pl-0 pr-0">
      <div class="row">
        <div class="form-group col-sm-6 col-md-3">
          <label for>Filter</label>
          <div class="search-div position-relative">
            <input type="text" placeholder="Search" class="form-control" v-model="search" />
            <div v-if="search !== ''" class="search-svg position-absolute" @click="clearSearch()">
              <crossSVG />
            </div>
          </div>
        </div>
        <div class="form-group col-sm-6 col-md-3">
          <div class="position-relative">
            <label for>Status</label>
            <select name id class="form-control">
              <option value>All</option>
              <option value="open">Open</option>
              <option value="approved">Approved</option>
              <option value="rejected">Rejected</option>
            </select>

            <span class="drop-icon">
              <i aria-hidden="true" class="v-icon mdi mdi-menu-down theme--light position-absolute"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="table-div overflow-auto">
      <table class="table userlistTable small-table-width">
        <thead>
          <tr class="table-success">
            <th>Name</th>
            <th>Mobile</th>
            <th>Email</th>
            <th>Created Date</th>
            <th>Category</th>
            <th>Subject</th>
            <th>Priority</th>
            <th>Ticket Status</th>
            <th>Team Status</th>
            <th></th>
          </tr>
        </thead>
        <tbody v-for="(value, index) in ticketList" :key="index">
          <tr>
            <td class="capitalize-text">{{ value.user_name }}</td>
            <td>{{ value.mobile }}</td>
            <td>{{ value.email }}</td>
            <td>{{ getDate(value.created_at) }}</td>
            <td class="capitalize-text">{{ value.ticket_type }}</td>
            <td>{{ value.subject }}</td>
            <td class="capitalize-text">{{ value.priority }}</td>
            <td class="capitalize-text">{{ value.user_status }}</td>
            <td class="capitalize-text">
              {{
              value.assigned_to[value.assigned_to.length - 1]
              .assigned_user_status
              }}
            </td>
            <td></td>
            <td class="py-2">
              <v-btn
                class="btn btn-primary"
                square
                size="sm"
                @click="toggleDetails(value, index)"
              >{{ Boolean(value._toggled) ? 'Hide' : 'Show' }}</v-btn>
            </td>
          </tr>
          <tr>
            <td colspan="11" class="col-sm-12 border-0">
              <CCollapse
                class="col-sm-12 p-0"
                :show="Boolean(value._toggled)"
                :duration="collapseDuration"
              >
                <CCardBody class="col-sm-12 p-0">
                  <v-btn
                    size="sm"
                    class="btn btn-primary ml-1"
                    @click="informationDisplay = true"
                  >Description</v-btn>
                  <v-btn
                    size="sm"
                    class="btn btn-primary ml-1"
                    v-if="value.imageval"
                    @click="viewAffidavit(value)"
                  >View Attachment</v-btn>
                  <v-btn
                    size="sm"
                    class="btn btn-success ml-1"
                    v-if="
                    value.user_status == 'pending' &&
                      value.assigned_to[value.assigned_to.length - 1]
                        .assigned_user_status == 'pending'
                  "
                    @click="requestAccept(value)"
                  >Accept</v-btn>
                  <v-btn
                    size="sm"
                    class="btn btn-primary ml-1"
                    v-if="
                    value.assigned_to[value.assigned_to.length - 1]
                      .assigned_user_status == 'accepted'
                  "
                    @click="resolveAndReject(value, true)"
                  >Resolved</v-btn>
                  <v-btn
                    size="sm"
                    class="btn btn-danger ml-1"
                    @click="rejectModal = true"
                    v-if="
                    value.assigned_to[value.assigned_to.length - 1]
                      .assigned_user_status == 'accepted'
                  "
                  >Reject</v-btn>
                  <v-btn
                    size="sm"
                    class="btn btn-danger ml-1"
                    v-if="
                    value.assigned_to[value.assigned_to.length - 1]
                      .assigned_user_status == 'pending'
                  "
                    @click="reAssign = true"
                  >Re-Assign</v-btn>
                  <div>
                    <CModal title="Description" color="dark" :show.sync="reAssign">
                      <div class="col-sm-12">
                        <CTextarea
                          label="Reason"
                          name="reason"
                          v-model="reason"
                          placeholder="Reason"
                          horizontal
                          rows="2"
                          v-validate="'required'"
                        />
                        <span class="text-danger">
                          {{
                          errors.first('reason')
                          }}
                        </span>
                      </div>
                      <template #header>
                        <h6 class="modal-title">Reason for Re-Assign</h6>
                        <CButtonClose @click="reAssign = false" class="text-white" />
                      </template>
                      <template #footer>
                        <!-- <CButton @click="reAssign = false" color="danger">Cancel</CButton> -->
                        <CButton color="success" @click="reAssignApi(value)">Submit</CButton>
                      </template>
                    </CModal>
                    <CModal title="Description" color="dark" :show.sync="rejectModal">
                      <CTextarea
                        label="Reason"
                        name="reason"
                        v-model="rejectReason"
                        placeholder="Reason"
                        horizontal
                        rows="2"
                      />
                      <span class="text-danger">
                        {{
                        errors.first('reason')
                        }}
                      </span>
                      <template #header>
                        <h6 class="modal-title">Reason for Reject</h6>
                        <!-- <CButtonClose @click="rejectModal = false" class="text-white" /> -->
                      </template>
                      <template #footer>
                        <CButton @click="rejectModal = false" color="danger">Cancel</CButton>
                        <CButton color="success" @click="resolveAndReject(value, false)">Submit</CButton>
                      </template>
                    </CModal>
                    <CModal title="Description" color="dark" :show.sync="informationDisplay">
                      <div class="col-sm-12">
                        <h6>{{ value.description }}</h6>
                      </div>
                      <template #footer>
                        <CButton @click="informationDisplay = false" color="danger">Cancel</CButton>
                      </template>
                    </CModal>
                    <CModal
                      :show.sync="affidavitModal"
                      :no-close-on-backdrop="true"
                      :centered="true"
                      title="Modal title 2"
                      size="lg"
                      color="dark"
                      :details="affidavitData"
                    >
                      <CImg
                        v-if="
                        typeOfDocument == 'png' ||
                          typeOfDocument == 'jpeg' ||
                          typeOfDocument == 'jpg' ||
                          typeOfDocument == 'webp'
                      "
                        :src="affidavitData.imageval"
                        block
                        class="mb-2"
                        width="470"
                        height="600"
                      />
                      <embed
                        v-else-if="typeOfDocument == 'pdf'"
                        :src="src"
                        style="width: 100%;height:800px"
                      />
                      <template #header>
                        <h6 class="modal-title">Affidavit</h6>
                        <!-- <CButtonClose @click="affidavitModal = false" class="text-white" /> -->
                      </template>
                      <template #footer>
                        <CButton @click="affidavitModal = false" color="danger">Cancel</CButton>
                      </template>
                    </CModal>
                  </div>
                </CCardBody>
              </CCollapse>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <CPagination
      class="pagination-block"
      align="end"
      :active-page.sync="currentPage"
      :pages="totalPage"
      @update:activePage="changePage"
    />
  </div>
</template>

<script>
import { pickSvg } from "@/views/SVG";
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .isBetween()
  .build();
import config from "@/config.js";
import { mapGetters, mapState } from "vuex";
export default {
  $_veeValidate: {
    validator: "new"
  },
  name: "AdvancedTables",
  data() {
    return {
      dayJS,
      details: [],
      collapseDuration: 0,
      ticketList: [],
      val: "",
      collaps: false,
      priority: "",
      informationDisplay: false,
      affidavitModal: false,
      affidavitData: {},
      typeOfDocument: "",
      src: "",
      remark: "",
      currentPage: 1,
      totalPage: 1,
      recordPerPage: 10,
      reAssign: false,
      reason: "",
      search: "",
      userInfo: {},
      rejectReason: "",
      rejectModal: false
    };
  },
  components: {
    ...pickSvg("crossSVG")
  },
  computed: {
    ...mapGetters({
      userDetails: "getUserDetails"
    })
  },
  mounted() {
    this.getList();
  },
  watch: {
    userDetails: {
      handler(newValue) {
        this.userInfo = newValue;
      },
      deep: true
    }
  },
  methods: {
    getDate(date) {
      return dayJS(date).format("DD-MM-YYYY h:mm A");
    },
    clearSearch() {
      this.search = "";
    },
    viewAffidavit(item) {
      this.affidavitModal = true;
      let fileDetails = item && item.imageval.split(".");
      this.typeOfDocument = fileDetails[fileDetails.length - 1];
      this.src = item.imageval;
      this.affidavitData = item;
    },
    changePage(currentPage, reduced) {
      this.currentPage = currentPage;
      this.getList();
    },
    getList() {
      let url = `${config.BASE_URL}api/v2/admin/ticket/user/listing/${this.currentPage}/${this.recordPerPage}`;
      this.$http.get(url).then(response => {
        if (response.body.status) {
          this.ticketList = [...response.body.data.data.list];
          this.totalPage =
            response.body.data.data.total_records / this.recordPerPage;
          if (response.body.data.data.total_records % this.recordPerPage !== 0)
            this.totalPage = parseInt(JSON.stringify(this.totalPage)) + 1;
        }
      });
    },
    reAssignApi(item) {
      let obj = {
        ticket_id: item._id,
        remark: this.reason,
        assigned_id: this.userDetails._id,
        assigned_member:
          this.userDetails.first_name + " " + this.userDetails.last_name
      };
      let url = `${config.BASE_URL}api/v2/admin/ticket/user/reassign`;
      this.$http.post(url, obj).then(response => {
        if (response.body.status) {
          this.reAssign = false;
          this.getList();
        }
      });
    },
    requestAccept(item) {
      let obj = {
        ticket_id: item._id
      };
      let url = `${config.BASE_URL}api/v2/admin/ticket/user/request-accept`;
      this.$http.post(url, obj).then(response => {
        if (response.body.status) {
          this.getList();
        }
      });
    },
    resolveAndReject(item, valid) {
      let obj = {
        ticket_id: item._id,
        assigned_user_status: valid ? "done" : "declined",
        remark: valid ? "" : this.rejectReason,
        user_status: valid ? "done" : "declined"
      };
      let url = `${config.BASE_URL}api/v2/admin/ticket/user/resolve-reject`;
      this.$http.post(url, obj).then(response => {
        if (response.body.status) {
          this.rejectModal = false;
          this.getList();
        }
      });
    },
    toggleDetails(item, index) {
      this.$set(this.ticketList[index], "_toggled", !item._toggled);
      this.collapseDuration = 300;
      this.$nextTick(() => {
        this.collapseDuration = 0;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.capitalize-text {
  text-transform: capitalize;
}
.text-danger {
  font-size: 0.7vw;
}
</style>
